import React from 'react';
import { Col, Input } from 'reactstrap';
import moment from 'moment';
import DateRangePickerComp from 'components/DatePicker/DateRangePicker';

const Filter = (props) => {

    const transactionTypes = [{ id: 'debit', name: 'Debit' }, { id: 'credit', name: 'Credit' }];
    const [defaultRange] = React.useState(null);
    const [filterValues, setFilterValues] = React.useState({
        transaction_type: '',
        keyword: '',
        start_date: '',
        end_date: ''
    });
    const handleChange = (event) => {
        setFilterValues(
            { ...filterValues, [event.target.name]: event.target.value }
        )
    }
    const handleDateChange = (date) => {
        if (date && date.startDate) {
            const startDate = moment(date.startDate).format('YYYY-MM-DD');
            const endDate = moment(date.endDate).format('YYYY-MM-DD');
            setFilterValues(
                { ...filterValues, 'start_date': startDate, 'end_date': endDate }
            )
        }
    }
    const handleSearch = () => {
        props.handleSearch(filterValues)
    }
    return (
        <div>

            <DateRangePickerComp handleDateChange={handleDateChange} handleSearch={handleSearch} defaultRange={defaultRange} >
                <Col lg={2} md={6} sm={6} xs={8} >
                    <Input
                        type="text"
                        name="keyword"
                        id="keyword"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(filterValues.keyword) ? filterValues.keyword : ''}
                        placeholder={'Search by customer or campaign'}
                        style={{ width: 170, marginBottom: 10 }}
                    />
                </Col>
                <Col lg={2} md={6} sm={6} xs={8} >
                    <Input name={'transaction_type'} onChange={handleChange} className="mb-2"
                        type="select" defaultValue={(filterValues.transaction_type) ? filterValues.transaction_type : ''}
                        style={{ width: 170 }}>
                        <option value={0}>Select Transaction Type</option>
                        {transactionTypes.map((item) => (<option key={item.id} value={item.id}>{item.name}</option>))}
                    </Input>
                </Col>
            </DateRangePickerComp>
        </div>
    );
}

export default Filter;